import { PigmentBottle } from "@/components/kit/PigmentBottle";

const ACRYLIC = "bg-gradient-to-b from-white/50 via-white/25 to-white/60 backdrop-blur-[2px]";

export function Shelf({ items, perRow, renderCaption, testId, compact = false, rim = true, bottleMax = 120 }) {
  return (
    <div data-testid={testId}>
      <div className="relative">
        <div className="absolute inset-x-0 bottom-0 h-[44%] rounded-[10px] border border-white/80 shadow-[inset_0_1px_0_rgba(255,255,255,.9),0_10px_24px_rgba(44,24,16,.08)]" aria-hidden="true">
          <div className={`absolute inset-0 rounded-[10px] ${ACRYLIC}`} />
          <div className="absolute inset-0 grid" style={{ gridTemplateColumns: `repeat(${perRow}, minmax(0, 1fr))` }}>
            {Array.from({ length: perRow }).map((_, i) => <span key={i} className={i ? "border-l border-white/80" : ""} />)}
          </div>
          {rim && <div className="absolute inset-x-0 -bottom-1 h-2 rounded-full bg-gradient-to-b from-[#E9D3A6] via-[#C9A66B] to-[#9E7C45]" />}
        </div>
        <div className="relative grid px-2 pb-2.5" style={{ gridTemplateColumns: `repeat(${perRow}, minmax(0, 1fr))` }}>
          {items.map((it, i) => (
            <div key={it.id} className="mx-auto flex w-full flex-col items-center px-1.5" style={{ maxWidth: bottleMax }}>
              <PigmentBottle item={it} compact={compact} testId={testId ? `${testId}-bottle-${i}` : undefined} />
            </div>
          ))}
        </div>
      </div>
      {renderCaption && (
        <div className="relative mt-3 grid" style={{ gridTemplateColumns: `repeat(${perRow}, minmax(0, 1fr))` }}>
          {items.map((it) => <div key={it.id} className="min-w-0 px-1">{renderCaption(it)}</div>)}
        </div>
      )}
    </div>
  );
}

export function GoldBase({ label = "INK GENIUS" }) {
  return (
    <div className="relative -mt-1 flex h-11 items-center justify-center rounded-b-2xl rounded-t-md bg-gradient-to-b from-[#EED9AE] via-[#D2B079] to-[#A9844B] shadow-[0_14px_30px_rgba(120,90,40,.25)]">
      <span className="absolute inset-x-4 top-0 h-px bg-white/70" />
      <span className="font-serif text-sm tracking-[0.35em] text-[#5B4220]">{label}</span>
    </div>
  );
}
